module.exports = __webpack_public_path__ + "static/media/icon_challenge.4fd27730.svg";